import UserService from 'services/UserService';

import * as UserActionTypes from 'actiontypes/user';
import { closeSidebar } from 'actions/sidebar';
import clearAuthenticationTokens from 'startup/clearAuthenticationTokens';

const service = new UserService();


/** ----------------------------------------------------------------------------
 * LOGOUT - logout a user
 -----------------------------------------------------------------------------*/
export default function logoutUser() {
  return async (dispatch) => {
    // Remove any authentication tokens in local/session storage
    clearAuthenticationTokens();

    // Ensure that we close the sidebar when we're trying to log out
    dispatch(closeSidebar());
    try {
      // Let the store know we're logging out. No matter what, we're
      // going to clobber the store and go to /login
      dispatch(logoutSuccess());
      // Let the API know we're logging out
      await service.logout();
      window.location = '/login';
    } catch (error) {
      // Swallow errors; let's log the hell out without crashing, eh?
      console.error(error);
    }
  };
}

const logoutSuccess = () => ({
  type: UserActionTypes.LOGOUT_SUCCESS,
  isFetching: false,
  loggedIn: false,
  loginError: false,
});